import { axios } from "@/redux/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";

type props = {
  fromDate?: string;
  toDate?: string;
};
export const ReportThunk = createAsyncThunk("report", async (data: props, { rejectWithValue }) => {
  try {
    const res = await axios.get("/v1/report/general", {
      headers: { "Content-Type": "application/json" },
      params: {
        ...data,
        fromDate: moment(data?.fromDate).format("YYYY-MM-DD HH:mm"),
        toDate: moment(data?.toDate)
          .add(moment(data?.toDate).format("HH") == "23" ? 0 : 86369, "seconds")
          .format("YYYY-MM-DD HH:mm"),
      },
    });

    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const ReportProductsThunk = createAsyncThunk(
  "report_product_stat",
  async (data: props, { rejectWithValue }) => {
    try {
      const res = await axios.get("/v1/transactions/product-stats", {
        headers: { "Content-Type": "application/json" },
        params: {
          ...data,
          from: data?.fromDate && moment(data?.fromDate).format("YYYY-MM-DD HH:mm"),
          to:
            data?.toDate &&
            moment(data?.toDate)
              .add(moment(data?.toDate).format("HH") == "23" ? 0 : 86369, "seconds")
              .format("YYYY-MM-DD HH:mm"),
        },
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const ReportGroupedThunk = createAsyncThunk(
  "report_grouped_week",
  async ({ data = "weekly", filters }: { data: "weekly" | "monthly", filters?: any }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/v1/report/${data}`, {
        headers: { "Content-Type": "application/json" },
        params: filters
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetDailyRevenueThunk = createAsyncThunk(
  "report_daily_revenue",
  async (filters: any = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/v1/report/daily-transaction-report`, {
        headers: { "Content-Type": "application/json" },
        params: filters
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetRecentPlayersThunk = createAsyncThunk(
  "report_recent_players",
  async (filters: any = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/v1/report/top-ten/recent`, {
        headers: { "Content-Type": "application/json" },
        params: filters
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetDailyTransactionReportThunk = createAsyncThunk("report_daily_transaction", async (filters: any = {}, { rejectWithValue }) => {
  try {
    const res = await axios.get("/v1/report/daily-transaction-report", { params: filters });
    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const GetMonthlyTransactionReportThunk = createAsyncThunk("report_monthly_transaction", async ( { rejectWithValue }:any) => {
  try {
    const res = await axios.get("/v1/report/monthly-transaction-report");
    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});


export const GetHourlyTransactionReportThunk = createAsyncThunk(
  "report_hourly_transaction",
  async (filters: any = {}, { rejectWithValue }) => {
    try {
      // Get current date in YYYY-MM-DD format if no date is provided
      const today = new Date().toISOString().split("T")[0];
      const params = { date: today, ...filters };

      const res = await axios.get("/v1/report/hourly-transaction-report", { params });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const GetBackfillTelecomSummaryThunk = createAsyncThunk("report_backfill_telecom_summary", async (filters: any = {}, { rejectWithValue }) => {
  try {
    const res = await axios.get("/v1/report/backfill-telecom-summary", { params: filters });
    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const GetProductMonthlyTransactionReportThunk = createAsyncThunk("report_product_monthly_transaction", async (filters: any = {}, { rejectWithValue }) => {
  try {
    const res = await axios.get("/v1/report/product-monthly-transaction-report", { params: filters });
    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const GetProductDailyTransactionReportThunk = createAsyncThunk("report_product_daily_transaction", async (filters: any = {}, { rejectWithValue }) => {
  try {
    const res = await axios.get("/v1/report/product-daily-transaction-report", { params: filters });
    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const GetProductHourlyTransactionReportThunk = createAsyncThunk("report_product_hourly_transaction", async (filters: any = {}, { rejectWithValue }) => {
  try {
    const res = await axios.get("/v1/report/product-hourly-transaction-report", { params: filters });
    if (res?.data?.error) return rejectWithValue(res?.data?.error);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});